const settings = {
  title: "Settings",
  locale: "Locale",
  rows_per_page: "Rows per page",
  pin_title: "PIN Code",
  change_pin_title: "Change Pin",
  digit_pin: "Enter 4 Digit Pin",
  pin_not_set: "Pin not set",
}
export default settings
